<nav class="modern-sidebar-header">
  <div class="brand-container">
    <a class="brand-link" [routerLink]="['/subscription']">
      <div class="brand-logo">
        <img src="/assets/images/Core-logo.svg" alt="Core Logo" class="logo-img"/>
      </div>
      <!-- <div class="brand-text">
        <span class="brand-name">Core</span>
        <span class="brand-subtitle">Management</span>
      </div> -->
    </a>
  </div>
</nav>

<!-- main navigation -->
<nav class="modern-menu-container" *ngIf="!options.settings">
  <div class="menu-wrapper">
    <app-menu (menuItemClicked)="onMenuItemClicked()"></app-menu>
  </div>
</nav>

<nav class="menu" *ngIf="options.settings">
  <ul class="navigation">
    <li class="navigation-item">
      <a class="navigation-link" [routerLink]="['/social']">
        <i class="icon ion-ios-navigate me-3"></i>
        <span class="title me-auto">Profile</span>
      </a>
    </li>
    <li class="navigation-item">
      <a class="navigation-link">
        <i class="icon ion-ios-bell me-3"></i>
        <span class="title me-auto">Notifications</span>
      </a>
    </li>
    <!-- <li class="navigation-item">
      <a class="navigation-link" [routerLink]="['/account/lockscreen']">
        <i class="icon ion-ios-locked mr-3"></i>
        <span class="title mr-auto">Lockscreen</span>
      </a>
    </li> -->
    <li class="navigation-item">
      <hr />
    </li>
    <li class="navigation-item">
      <div class="navigation-link" (click)="options.docked = !options.docked; sendMessage()">
        <label class="custom-control custom-checkbox mb-0 me-3">
          <input class="custom-control-input" type="checkbox" [(ngModel)]="options.docked">
          <span class="custom-control-label"></span>
        </label>
        <span class="title me-auto">Docked mode</span>
      </div>
    </li>
    <li class="navigation-item">
      <a class="navigation-link" (click)="toggleFullscreen.emit()">
        <i class="icon ion-ios-eye me-3"></i>
        <span class="title me-auto">Fullscreen</span>
      </a>
    </li>
    <li class="navigation-item">
      <div class="navigation-link" (click)="options.boxed = !options.boxed; sendMessage()">
        <label class="custom-control custom-checkbox mb-0 me-3">
          <input class="custom-control-input" type="checkbox" [(ngModel)]="options.boxed">
          <span class="custom-control-label"></span>
        </label>
        <span class="title me-auto">Boxed</span>
      </div>
    </li>
    <li class="navigation-item">
      <hr />
    </li>
    <li class="navigation-item">
      <div class="navigation-title">Themes</div>
    </li>
    <li class="navigation-item" [ngClass]="{'open': options.theme === 'eclipse'}">
      <a class="navigation-link" (click)="setTheme('eclipse')">
        <i class="icon ion-ios-moon me-3"></i>
        <span class="title me-auto">Eclipse</span>
      </a>
    </li>
    <li class="navigation-item" [ngClass]="{'open': options.theme === 'winter'}">
      <a class="navigation-link" (click)="setTheme('winter')">
        <i class="icon ion-ios-snowy me-3"></i>
        <span class="title me-auto">Winter</span>
      </a>
    </li>
    <li class="navigation-item" [ngClass]="{'open': options.theme === 'spring'}">
      <a class="navigation-link" (click)="setTheme('spring')">
        <i class="icon ion-ios-flower me-3"></i>
        <span class="title me-auto">Spring</span>
      </a>
    </li>
    <li class="navigation-item" [ngClass]="{'open': options.theme === 'autumn'}">
      <a class="navigation-link" (click)="setTheme('autumn')">
        <i class="icon ion-ios-medical me-3"></i>
        <span class="title me-auto">Autumn</span>
      </a>
    </li>
    <li class="navigation-item" [ngClass]="{'open': options.theme === 'summer'}">
      <a class="navigation-link" (click)="setTheme('summer')">
        <i class="icon ion-ios-flame me-3"></i>
        <span class="title me-auto">Summer</span>
      </a>
    </li>
    <li class="navigation-item docked-hidden">
      <hr />
    </li>
    <li class="navigation-item docked-hidden">
      <div class="px-4 d-flex align-items-center">
        <select class="custom-select" [(ngModel)]="options.lang" #langSelect="ngModel" (ngModelChange)="translate.use(options.lang)"
          placeholder="Select language" style="min-width: 100%;">
          <option *ngFor="let lang of translate.getLangs()" [value]="lang">{{ lang }}</option>
        </select>
      </div>
    </li>
  </ul>
</nav>
<!-- /main navigation -->
